/**
 * Screen-space effect feel — single knob file (constants extraction,
 * 2026-06-12).
 *
 * Consumed by VFXSystem's screen-effect block (flash defaults, the low-HP
 * warning pulse, and the shaderless vignette overlay).
 */
export const SCREEN_EFFECTS_CONFIG = {
  /** screenFlash() defaults when callers pass nothing. */
  flash: { color: 0xffffff, durationMs: 200 },
  /** `net:periodicSync` low-HP warning: red flash below this HP fraction. */
  lowHpWarning: { hpFraction: 0.25, color: 0xff0000, durationMs: 200 },
  /** Shaderless vignette: four border rects that fade in, hold, fade out. */
  vignette: {
    /** Border thickness = min(viewport w, h) × this. */
    borderFraction: 0.15,
    /** Border fill alpha = intensity × this. */
    fillAlphaMultiplier: 0.6,
    /** Fade-in phase as a fraction of durationMs (fall mirrors it). */
    risePhase: 0.3,
    /** Full-intensity hold phase as a fraction of durationMs. */
    holdPhase: 0.4,
    /** Overlay render depth (over everything). */
    depth: 9999,
    /** Viewport fallback when no CameraSystem is registered. */
    fallbackWidth: 1280,
    fallbackHeight: 720,
  },
} as const;
